<template>
  <div>
    <version-list
      :value="versionList"
      :selected.sync="selectedVersionList"
      :loading="loadingData"
      :search="search"
    />
    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedVersionList.length"
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedVersionList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="/multiproject/versions/create"
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import VersionList from '../components/VersionList'

export default {
  name: 'VersionListContainer',
  components: {
    AgFloatButtonContainer,
    AgConfirmDialog,
    VersionList,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    versionList: [],
    selectedVersionList: [],
    loadingData: false,
    loadingRemove: false,
  }),
  computed: {
    removeMessage () {
      const count = this.selectedVersionList.length
      return this.$tc('multiproject.remove.messageVersion', count, { count })
    },
    hasDefaultVersionInSelected () {
      return this.selectedVersionList
        .some(version => version.defaultVersion)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'MultiprojectVersionList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.versionList = await Repositories.multiProject.version.getList()
      this.loadingData = false
    },
    async removeSelected () {
      if (this.hasDefaultVersionInSelected) {
        const notification = this.$t('multiproject.remove.cantRemoveDefaultVersion')
        this.showErrorNotification(notification)
      }
      else {
        try {
          this.loadingRemove = true
          const count = this.selectedVersionList.length
          const idList = this.selectedVersionList.map(version => version.id)
          await Repositories.multiProject.version.delete(idList)
          const notification = this.$tc('multiproject.remove.successVersion', count, { count })
          this.showSuccessNotification(notification)
        }
        catch (error) {
          const notification = Repositories.parseErrorMessage(error)
          this.showErrorNotification(notification)
        }
        finally {
          this.loadingRemove = false
          this.selectedVersionList = []
          this.fetchData()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
